import {ETIQUETA_ESTADO_DE_CARPETA, ETIQUETA_ESTADO_DE_CARPETA_EN} from '@cnc/contracts';
import {ErrorDeApi} from '../api/cliente';
import {useCarpetaDeExportacion, useRevisarCarpetaDeExportacion} from '../api/carpetas';
import {et, tr} from '../i18n/idioma';
import {fechaHora} from '../utilidades/formato';
import {useNivel} from './sesion-contexto';

// La carpeta de la exportacion en Dropbox (decision 0084): donde esta, un
// enlace para abrirla y el boton para revisarla (la crea si falta).
export function CarpetaEnDropbox({
  codigo,
  raiz,
  area = 'exportaciones.seguimiento',
}: {
  codigo: string;
  raiz?: string;
  area?: string;
}) {
  const carpeta = useCarpetaDeExportacion(codigo, raiz);
  const revisar = useRevisarCarpetaDeExportacion(codigo, raiz);
  const edita = useNivel(area) === 'editar';
  const c = carpeta.data;
  if (!c || c.estado === 'sin_conexion' || c.estado === 'sin_tipo') return null;
  const error = revisar.error instanceof ErrorDeApi ? revisar.error.message : (c.error ?? null);
  return (
    <section className="rounded-lg border border-linea bg-white p-5 text-sm">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h2 className="font-medium">{tr('Carpeta en Dropbox', 'Dropbox folder')}</h2>
        <span
          className={c.estado === 'ok' ? 'text-verde-oscuro' : c.estado === 'error' ? 'text-alerta' : 'text-apagado'}
        >
          {et(ETIQUETA_ESTADO_DE_CARPETA, ETIQUETA_ESTADO_DE_CARPETA_EN)[c.estado]}
        </span>
      </div>
      {c.ruta ? (
        <p className="mt-2 break-all">
          {c.enlace ? (
            <a
              href={c.enlace}
              target="_blank"
              rel="noreferrer"
              className="text-verde underline hover:text-verde-oscuro"
            >
              {c.ruta}
            </a>
          ) : (
            c.ruta
          )}
        </p>
      ) : (
        <p className="mt-2 text-apagado">
          {tr(
            `Se creará con el nombre ${c.nombreEsperado ?? ''}.`,
            `It will be created with the name ${c.nombreEsperado ?? ''}.`,
          )}
        </p>
      )}
      {c.revisadaEl && (
        <p className="mt-1 text-xs text-apagado">
          {tr('Revisada el', 'Checked on')} {fechaHora(c.revisadaEl)}
          {c.creadaPorLaApp ? tr(' · la creó la app', ' · created by the app') : ''}
        </p>
      )}
      {error && <p className="mt-2 text-alerta">{error}</p>}
      {c.acciones.length > 0 && (
        <ul className="mt-2 list-disc pl-5 text-apagado">
          {c.acciones.map(a => (
            <li key={a}>{a}</li>
          ))}
        </ul>
      )}
      {edita && (
        <button
          type="button"
          onClick={() => revisar.mutate()}
          disabled={revisar.isPending}
          className="mt-3 rounded-md border border-linea px-3 py-1.5 hover:bg-fondo disabled:opacity-50"
        >
          {revisar.isPending
            ? tr('Revisando…', 'Checking…')
            : c.ruta
              ? tr('↻ Revisar la carpeta', '↻ Check the folder')
              : tr('+ Crear la carpeta', '+ Create the folder')}
        </button>
      )}
    </section>
  );
}
